export default __webpack_public_path__ + "static/media/icon-white.21df699b.png";